<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode"> "{{ editedEntity.riskDefinition.name | translate }} " {{ $t("common.update") }}</span>
        <span v-else>{{ $t("common.create") }}</span>
      </h2>

      <filter-select
        class="mt-4"
        id="riskDefinitionFilter"
        ref="riskDefinitionFilter"
        :placeholder="$t('risk.definition.text')"
        :multiple="!isEditMode"
        :isValid="!$v.form.riskDefinition.$invalid"
        :displayCount="3"
        @filter="onRiskDefinitionSearch"
        :selected="form.riskDefinition"
        @changed="riskDefinitionSelect"
        track="_id"
      />

      <filter-select
        class="mt-4"
        id="appliedControlFilter"
        ref="appliedControlFilter"
        :multiple="true"
        :selected="form.appliedControl"
        @filter="onAppliedControlSearch"
        @changed="onAppliedControlSelect"
        placeholder="Uygulanan Kontroller"
      />

      <br />
      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import SweetTextarea from "@c/form/sweet-textarea";
import { required } from "vuelidate/lib/validators";
const state = "riskDefinitionAppliedControl";

export default {
  components: { SweetTextarea },
  props: ["state"],
  data() {
    return {
      form: { riskDefinition: undefined, appliedControls: [] },
    };
  },
  validations: {
    form: {
      riskDefinition: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v && Object.keys(v).length > 0) {
          this.form = { ...v };
        } else {
          this.form = {};
        }
      },
    },
  },
  computed: {
    isWorkspaceLayout() {
      return this.state === "workspaceriskDefinitionAppliedControl";
    },
    isUpdating() {
      return this.$store.getters[`${this.state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${this.state}/editedEntity`];
    },
    isEditMode() {
      return this.editedEntity && this.$store.getters[`${this.state}/isEditMode`];
    },
  },
  async mounted() {},
  methods: {
    async save() {
      const riskDefinitions = this.isEditMode ? [this.form.riskDefinition] : this.form.riskDefinition;

      this.$emit("onSave", this.form._id, riskDefinitions, this.form.appliedControls);
    },

    async onRiskDefinitionSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceRiskDefinition" : "managementRiskDefinition";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, ...(!this.isWorkspaceLayout && { "scope.value": { value: "system", isObject: true } }) },
      });
      callback(response.data?.docs ?? []);
    },
    riskDefinitionSelect(item) {
      this.form = { ...this.form, riskDefinition: item };
    },

    async onAppliedControlSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceRiskAppliedControl" : "managementRiskAppliedControl";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 1000 },
        query: { name: { value }, ...(!this.isWorkspaceLayout && { "scope.value": { value: "system", isObject: true } }) },
      });

      callback(response.data?.docs ?? []);
    },
    onAppliedControlSelect(items) {
      this.form = { ...this.form, appliedControls: items };
    },
  },
};
</script>
